<template>
  <div>
    <v-card flat class="pa-1">
      <v-toolbar flat color="#FFF" short>
        <v-toolbar-title>Motivos para Compra de Oportunidade</v-toolbar-title>
      </v-toolbar>
      <v-tabs centered>
        <v-tab>
          <v-icon left>mdi-clipboard-list-outline</v-icon>
          Cadastros de Motivos
        </v-tab>
        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="desserts"
                item-key="idproduto"
                class="elevation-1 ml-4 mr-4"
                :search="search"
                :height="320"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>Lista de Motivos</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-spacer></v-spacer>
                    <v-text-field
                      class="mr-10"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Pesquisar"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2"
                      @click="
                        dialogCadastro = true;
                        editedIndex = -1;
                      "
                      >Novo</v-btn
                    >
                    <v-dialog
                      persistent
                      v-model="dialogCadastro"
                      max-width="600px"
                    >
                      <v-card>
                        <v-card-title>
                          <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-textarea
                                outlined
                                v-model="editedItem.descricao"
                                label="Descrição do Motivo*"
                                counter="200"
                                height="130"
                                :error-messages="descricaoErrors"
                                :error="
                                  editedItem.descricao.length > 200
                                    ? true
                                    : false
                                "
                                @input="$v.editedItem.descricao.$touch()"
                                @blur="$v.editedItem.descricao.$touch()"
                              ></v-textarea>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="close()"
                            >Sair</v-btn
                          >
                          <v-btn color="blue darken-1" text @click="save()"
                            >Salvar</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.acoes="{ item }">
                  <v-icon class="mr-5" @click="editar(item)">mdi-pencil</v-icon>
                  <v-icon @click="deletar(item)">mdi-delete</v-icon>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>
<script>
import CompraAPI from "./../../api/compra";
import { required } from "vuelidate/lib/validators";
export default {
  components: {},

  data() {
    return {
      search: "",
      editedIndex: -1,
      desserts: [],
      headers: [
        { text: "Id", value: "id" },
        { text: "Descrição Motivo", value: "descricao" },
        { text: "Ações", value: "acoes", align: "right", sortable: false },
      ],
      dialogCadastro: false,

      editedItem: {
        id: "",
        descricao: "",
      },
    };
  },

  computed: {
    descricaoErrors() {
      const errors = [];
      if (!this.$v.editedItem.descricao.$dirty) return errors;
      !this.$v.editedItem.descricao.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1
        ? "Novo Motivo para Compra de Oportunidade"
        : "Editar Motivo para Compra de Oportunidade";
    },
  },

  created() {
    this.buscarMotivos();
  },

  validations: {
    editedItem: {
      descricao: {
        required,
      },
    },
  },

  methods: {
    deletar(item) {
      if (confirm("Deseja excluir o Item?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = { id: item.id };

        this.$store.dispatch(
          "loading/addRequisicao",
          CompraAPI.delMotivoCompraOportunidade(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.buscarMotivos();
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },

    close() {
      this.editedItem = {
        id: "",
        descricao: "",
      };
      this.dialogCadastro = false;
    },

    buscarMotivos() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getMotivosCompraOportunidade(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.desserts = [];
              this.desserts = response.data.motivos;
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    editar(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogCadastro = true;
    },

    save() {
      if (!this.$v.$invalid && this.editedItem.descricao.length <= 200) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          CompraAPI.setMotivosCompraOportunidade(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.buscarMotivos();
                this.close();
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
  },
};
</script>
<style></style>
